const r=({spacing:t})=>({styleOverrides:{root:({ownerState:e})=>{const{position:o}=e,n=o==="left"||o==="right";return{paddingTop:t(1),paddingBottom:t(2),...n&&{flex:.2}}}}});export{r as default};
